import { booleanAttribute, Component, computed, input } from '@angular/core';

@Component({
  selector: 'mai-mib-logo',
  templateUrl: './mib-logo.html',
})
export class MibLogo {
  readonly size = input<'small' | 'medium' | 'large' | 'xl'>('small');
  readonly theme = input<'light' | 'dark'>('light');
  readonly stayLarge = input(false, { transform: booleanAttribute });

  readonly sizeClasses = computed(() => {
    switch (this.size()) {
      case 'small':
        return 'h-6';
      case 'medium':
        return 'h-7.5';
      case 'xl':
        return 'h-9.5';
      case 'large':
        return `${this.stayLarge() ? 'h-11 max-lg:landscape:h-6' : 'h-6 md:h-11 max-lg:landscape:h-6'}`;
    }
  });
  readonly colorClasses = computed(() =>
    this.theme() === 'dark' ? 'text-white' : 'text-branding-primary',
  );

  readonly mibClasses = computed(() => `${this.sizeClasses()} ${this.colorClasses()}`);
}
